import template from './commonicdchanges.html';
import controller from './commonicdchanges.controller';
import './commonicdchanges.styl';

let commonicdchangesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default commonicdchangesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchanges/commonicdchanges.component.js